// extracted by mini-css-extract-plugin
export var button = "Banner-module--button--a68be";
export var carousel = "Banner-module--carousel--0b5aa";
export var container = "Banner-module--container--fde6f";
export var decor = "Banner-module--decor--b58ed";
export var lineAbove = "Banner-module--lineAbove--59b67";
export var overlay = "Banner-module--overlay--1efc7";
export var position = "Banner-module--position--c1f33";
export var relativeWrapper = "Banner-module--relativeWrapper--231dd";